// permissions par pages
export const CAN_ACCESS_ADDRESS = "CAN_ACCESS_ADDRESS";
export const CAN_ACCESS_RIDES = "CAN_ACCESS_RIDES";
export const CAN_ACCESS_COMPANY_CLIENT = "CAN_ACCESS_COMPANY_CLIENT";
export const CAN_ACCESS_COMPANY_BACKOFFICE = "CAN_ACCESS_COMPANY_BACKOFFICE";
export const CAN_ACCESS_PROFILE_CLIENT = "CAN_ACCESS_PROFILE_CLIENT";
export const CAN_ACCESS_PROFILE_BACKOFFICE = "CAN_ACCESS_PROFILE_BACKOFFICE";
export const CAN_ACCESS_CLIENTS_ADMIN = "CAN_ACCESS_CLIENTS_ADMIN";
export const CAN_ACCESS_DRIVERS_ADMIN = "CAN_ACCESS_DRIVERS_ADMIN";
export const CAN_ACCESS_VEHICLES_ADMIN = "CAN_ACCESS_VEHICLES_ADMIN";
export const CAN_ACCESS_COURSES_ADMIN = "CAN_ACCESS_COURSES_ADMIN";
export const CAN_ACCESS_COMPANIES_ADMIN = "CAN_ACCESS_COMPANIES_ADMIN";
export const CAN_ACCESS_DRIVER_DETAIL_ADMIN = "CAN_ACCESS_DRIVER_DETAIL_ADMIN";

export const CAN_MANAGE_ALL_DRIVERS = "CAN_MANAGE_ALL_DRIVERS";
export const CAN_MANAGE_OWN_DRIVERS = "CAN_MANAGE_OWN_DRIVERS";

export const CAN_ACCESS_DRIVER_MANAGER_PROFILE =
  "CAN_ACCESS_DRIVER_MANAGER_PROFILE";
export const CAN_ACCESS_DRIVER_PROFILE = "CAN_ACCESS_DRIVER_PROFILE";

export const CAN_MANAGE_COMPLETE_DRIVER_PROFILE =
  "CAN_MANAGE_COMPLETE_DRIVER_PROFILE";
